module.exports = __webpack_public_path__ + "img/struts2.f0eced74.svg";